import { memo } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Tables render at content width; the drawer can be as narrow as 340px, so
// wide tables scroll horizontally inside the bubble instead of overflowing.
// useTabSwipe exempts horizontally-scrollable elements, so this wrapper also
// keeps table swipes from switching tabs on mobile.
const markdownComponents = {
  // Destructure `node` so react-markdown's AST node never reaches the DOM element
  table: ({ node, ...props }) => ( // eslint-disable-line no-unused-vars
    <div className="chat-table-wrap">
      <table {...props} />
    </div>
  ),
  // Internal links (e.g. the demo's /signup CTA) render as a call-to-action button;
  // external links keep the default anchor rendering so prod chat is unaffected.
  a: ({ node, href, children, ...props }) => { // eslint-disable-line no-unused-vars
    if (href && href.startsWith('/')) {
      return <a href={href} className="chat-cta-button" {...props}>{children}</a>;
    }
    return <a href={href} {...props}>{children}</a>;
  },
};

function formatTime(timestamp) {
  if (!timestamp) return '';
  try {
    const d = new Date(timestamp);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}

// Memoized: messages are immutable once posted, so this skips re-rendering (and
// re-running react-markdown) when an unrelated state change — e.g. the input box
// updating on every keystroke while a question types out — re-renders the drawer.
function ChatMessage({ role, content, timestamp }) {
  const isAssistant = role === 'assistant';

  return (
    <div className={`chat-message ${role}`}>
      <div className="chat-bubble">
        <div className="chat-bubble-text">
          {isAssistant
            ? <Markdown remarkPlugins={[remarkGfm]} components={markdownComponents}>{content}</Markdown>
            : content}
        </div>
      </div>
      {timestamp && (
        <span className="chat-timestamp">{formatTime(timestamp)}</span>
      )}
    </div>
  );
}

export default memo(ChatMessage);
